// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// 自动引入处理组件插件
import componentsList from './utils/componentsRegister';
Vue.use(componentsList);

// vue-fragment
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// vuex
import store from './store/index'
Vue.prototype.$store = store;

// vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// wxShare
import * as wxShare from './utils/wxShare'
Vue.prototype.$wxShare = wxShare;

// vconsole
// import VConsole from 'vconsole';
// const vConsole = new VConsole();

import * as api from '@/api/api.js';

Vue.prototype.$api = {
  ...api
};

// tool
import * as tool from './utils/tool'
Vue.prototype.$tool = tool;

// 项目前缀
Vue.prototype.$projectPrefix = 'cszx2025'

// storage
import * as storageUtil from './utils/storageUtil'
Vue.prototype.$storageUtil = storageUtil;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js